import { createContext, useContext, useState, useEffect } from "react";

const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([]);

  // Ajoute une nouvelle notification
  const showNotification = (type, message, duration = 10000) => {
    const id = Date.now();
    setNotifications((prev) => [...prev, { id, type, message }]);

    // Auto-fermeture après `duration` ms
    setTimeout(() => {
      setNotifications((prev) => prev.filter((n) => n.id !== id));
    }, duration);
  };

  // Fermeture manuelle
  const closeNotification = (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}

      {/* Zone des notifications */}
      <div className="fixed top-5 right-5 z-[9999] space-y-3">
        {notifications.map((notif) => (
          <div
            key={notif.id}
            className={`flex items-start gap-3 px-4 py-3 rounded-xl shadow-lg text-white animate-fade-in-down relative
              ${
                notif.type === "success"
                  ? "bg-green-500"
                  : notif.type === "error"
                  ? "bg-red-500"
                  : notif.type === "warning"
                  ? "bg-yellow-500"
                  : "bg-blue-500"
              }
            `}
          >
            {/* <span className="text-lg">
              {notif.type === "success" && "✅"}
              {notif.type === "error" && "❌"}
              {notif.type === "warning" && "⚠️"}
              {notif.type === "info" && "ℹ️"}
            </span> */}

            <div className="flex-1 text-sm font-medium">{notif.message}</div>

            <button
              onClick={() => closeNotification(notif.id)}
              className="ml-2 text-white hover:opacity-80 transition"
            >
              <span className="text-white">
                <svg
                  width="20px"
                  height="20px"
                  viewBox="-0.5 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                  <g
                    id="SVGRepo_tracerCarrier"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <g id="SVGRepo_iconCarrier">
                    {" "}
                    <path
                      d="M3 21.32L21 3.32001"
                      stroke="#fff"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />{" "}
                    <path
                      d="M3 3.32001L21 21.32"
                      stroke="#fff"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />{" "}
                  </g>
                </svg>
              </span>
            </button>
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
}

export function useNotification() {
  return useContext(NotificationContext);
}
